import React from 'react';
import VisaLogo from 'images/icons/visa-card.svg';
import MasterCardLogo from 'images/icons/mastercard.svg';
import DiscoverCardLogo from 'images/icons/discover-card.svg';
import AmexCardLogo from 'images/icons/amex-card.svg';
import DinersLogo from 'images/icons/diners.svg';
import JcbLogo from 'images/icons/jcb.svg';
import UnionPayLogo from 'images/icons/unionpay.svg';
import GenericCardLogo from 'images/icons/generic-card.svg';

import { CARD_BRANDS } from 'constants/enums';

const logosByBrand = Object.freeze({
  [CARD_BRANDS.VISA]: VisaLogo,
  [CARD_BRANDS.MASTERCARD]: MasterCardLogo,
  [CARD_BRANDS.DISCOVER]: DiscoverCardLogo,
  [CARD_BRANDS.AMEX]: AmexCardLogo,
  [CARD_BRANDS.DISCOVER_DINERS]: DinersLogo,
  [CARD_BRANDS.JCB]: JcbLogo,
  [CARD_BRANDS.UNION_PAY]: UnionPayLogo,
});

const logos = new Proxy(logosByBrand, {
  get: (target, brand) => {
    return brand in target ? target[brand] : GenericCardLogo;
  },
});

const CardLogo = ({ brand }) => {
  return (
    <img
      style={{ height: '24px', width: '36px' }}
      src={logos[brand]}
      alt={brand}
    />
  );
};

export default CardLogo;
